const React = require('react');
const PropTypes = React.PropTypes;
const classNames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');

const TabPanel = React.createClass({

  propTypes: {
    tabs: PropTypes.arrayOf(PropTypes.shape({
      children: PropTypes.node.isRequired,
      key: PropTypes.string.isRequired,
    })),
    selectedIndex: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
  },

  mixins: [PureRenderMixin],

  _onChange(index) {
    if (index !== this.props.selectedIndex) {
      this.props.onChange(index);
    }
  },

  render() {

    const tabsDisplay = this.props.tabs.map((map, i) => {
      const tabClasses = classNames('TabPanel-tab', {
        'is-selected': i === this.props.selectedIndex,
      });

      return (
        // TODO(fn-bind): replace with cached function
        <div key={ map.key } onClick={ this._onChange.bind(this, i) } className={ tabClasses }>
          { map.children }
        </div>
      );
    });

    return (
      <section className="TabPanel">
        { tabsDisplay }
      </section>
    );
  },
});

module.exports = TabPanel;
